import { ElementRef, EventEmitter, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var FcCustomSelectComponent = /** @class */ (function () {
    function FcCustomSelectComponent(eRef, fuseTranslationLoaderService) {
        this.eRef = eRef;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.selectedOptionOutput = new EventEmitter();
        this.editOptionOutput = new EventEmitter();
        this.addOptionOutput = new EventEmitter();
        this.search = '';
        this.displayOptions = false;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    FcCustomSelectComponent.prototype.ngOnInit = function () {
        if (!this.label) {
            return;
        }
        this.label = this.label.toLowerCase();
    };
    FcCustomSelectComponent.prototype.ngOnChanges = function (changes) {
        if (changes.selectedOption && (changes.selectedOption.currentValue !== changes.selectedOption.previousValue)) {
            this.selectOption(changes.selectedOption.currentValue, true);
        }
    };
    FcCustomSelectComponent.prototype.selectOption = function (option, firstRun) {
        if (firstRun === void 0) { firstRun = false; }
        if (this.selectedOption === option && !firstRun) {
            return;
        }
        this.selectedOption = option;
        this.selectedOptionOutput.emit(option);
    };
    FcCustomSelectComponent.prototype.editOption = function (event, option) {
        event.stopPropagation();
        this.editOptionOutput.emit(option);
    };
    FcCustomSelectComponent.prototype.addOption = function (event) {
        event.stopPropagation();
        this.addOptionOutput.emit();
    };
    Object.defineProperty(FcCustomSelectComponent.prototype, "filteredOptions", {
        get: function () {
            var _this = this;
            if (!this.search) {
                return this.options;
            }
            return this.options.filter(function (option) { return option.name.toLowerCase().includes(_this.search.toLowerCase()); });
        },
        enumerable: true,
        configurable: true
    });
    FcCustomSelectComponent.prototype.clickout = function (event) {
        if (!this.eRef.nativeElement.contains(event.target) && this.displayOptions) {
            this.displayOptions = false;
        }
    };
    return FcCustomSelectComponent;
}());
export { FcCustomSelectComponent };
